import { render, staticRenderFns } from "./ProductCreationForm.vue?vue&type=template&id=8080dafc&scoped=true"
import script from "./ProductCreationForm.vue?vue&type=script&lang=js"
export * from "./ProductCreationForm.vue?vue&type=script&lang=js"
import style0 from "./ProductCreationForm.vue?vue&type=style&index=0&id=8080dafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8080dafc",
  null
  
)

export default component.exports